import React, { useEffect, useState } from 'react';
import ShowNotification from './Notification';
import apiService from '../Services/apiService';
import logo from '../Images/logo.png'

export default function Index() {

  const [step, setstep] = useState<number>(1);
  const [loading, setloading] = useState<boolean>(false);

  /* STEP 1 */
  const [name, setname] = useState<string>('');
  const [middlename, setmiddlename] = useState<string>('');
  const [lastname, setlastname] = useState<string>('');
  const [phone, setphone] = useState<string>('');
  const [mail, setmail] = useState<string>('');
  const [folio, setfolio] = useState<string>('');

  /* STEP 2 */
  const [marca, setmarca] = useState<string>('');
  const [modelo, setmodelo] = useState<string>('');
  const [year, setyear] = useState<string>('');
  const [placas, setplacas] = useState<string>('');
  const [fechacompra, setfechacompra] = useState<string>('');
  const [lugarcompra, setlugarcompra] = useState<string>('');

  useEffect(() => {
    const form: HTMLFormElement|null = document.getElementById("formDatosPersonales") as HTMLFormElement

    if(form !== null){
    for (let i = 0; i <= form.elements.length - 1; i++) {
      const input: HTMLInputElement = form.elements[i] as HTMLInputElement;
      input.setCustomValidity('')
      if (!input.validity.valid)
        input.setCustomValidity('Campo obligatorio.')
    }
  }
  }, [])

  useEffect(() => {
    let form:HTMLFormElement|null =null;
    
    if(step === 1)
      form = document.getElementById("formDatosPersonales") as  HTMLFormElement

    if(step === 2)
      form = document.getElementById("formDatosMoto") as  HTMLFormElement

    if(form !== null){
      for (let i = 0; i <= form.elements.length - 1; i++) {
        const input: HTMLInputElement = form.elements[i] as HTMLInputElement;
        input.setCustomValidity('')
        if (!input.validity.valid)
          input.setCustomValidity('Campo obligatorio.')
      }
    }
  }, [step])

  const submitFormStep1 = async (event: React.FormEvent<HTMLFormElement>) => {
    // Preventing the page from reloading
    event.preventDefault();
    event.stopPropagation()

    setloading(true)

    await setTimeout(async () => {

      const responseAPI = await apiService.validFolio({ inputFolio: folio })

      if (!responseAPI.success) {
        setloading(false)
        ShowNotification(responseAPI.data[0], responseAPI.data[1], "error")
      } else {
        // ShowNotificationCustom("Número de folio correcto","Número de folio correcto, favor de dar click en \"Aceptar\" para continuar con el proceso de registro", TypeNotification.info).then((response) => {
        //   if(response.result){        
        setloading(false)
        setstep(2)
        //   }
        // })

      }

    }, 1000);

  }

  const clearData = () => {
    setname('');
    setmiddlename('')
    setlastname('')
    setphone('')
    setmail('')
    setfolio('')
    setmarca('')
    setmodelo('')
    setyear('')
    setplacas('')
    setfechacompra('')
    setlugarcompra('')

    setstep(1)
  }

  const submitCompleteRegister = async (event: React.FormEvent<HTMLFormElement>) => {
    // Preventing the page from reloading
    event.preventDefault();
    event.stopPropagation()

    setloading(true)

    await setTimeout(async () => {

      const responseAPI = await apiService.store({
        inputFolio: folio,
        inputName: name,
        inputMiddleName: middlename,
        inputLastName: lastname,
        inputPhone: phone,
        inputAddress: lugarcompra,
        inputMarca: marca,
        inputModelo: modelo,
        inputYear: year,
        inputPlacas: placas,
        inputDate: fechacompra,
        inputEmail: mail
      })

      if (!responseAPI.success) {
        setloading(false)
        ShowNotification("Error", responseAPI.data.length > 1 ? responseAPI.data.join('<br />') : responseAPI.data[0], "error")
      } else {
        ShowNotification("Confirmación", "¡Registro exitoso!, hemos enviado la confirmación de su registro al correo <strong>" + mail + "</strong>, por favor revise su bandeja de entrada.", "success").then(() => {
          setloading(false)
          clearData()
        });
      }

    }, 1000);



  }

  const backStep = (event: React.FormEvent<HTMLButtonElement>) => {
    // Preventing the page from reloading
    event.preventDefault();

    setstep(1);

  }

  // const OnInvalidEvent = (event: React.FormEvent<HTMLInputElement>) => {
  //   event.preventDefault()
  //   event.stopPropagation()
  //   const input: HTMLObjectElement = event.target as HTMLObjectElement;
  //   const form: HTMLFormElement = document.getElementById("formDatosPersonales") as HTMLFormElement
  //   for (let i = 0; i <= form.elements.length - 1; i++) {
  //         const inputForm: HTMLObjectElement = form.elements[i] as HTMLObjectElement;
  //         if (inputForm.nodeValue === null && input.id === inputForm.id)
  //         console.log(inputForm)
  //           input.setCustomValidity('Campo obligatorio.')
  //           input.reportValidity()
  //           break;
  //       }
  // }

  const OnInputEvent = (event: React.FormEvent<HTMLInputElement>) => {
    event.preventDefault()
    event.stopPropagation()
    const input: HTMLObjectElement = event.target as HTMLObjectElement;

    if (input.validity.valueMissing && !input.validity.badInput) {
      console.log(input)
      input.setCustomValidity('Campo obligatorio.')
    }
    else if (input.validity.valueMissing && input.validity.badInput) {
      if (input.type === "number") {
        input.setCustomValidity('Solo se aceptan números')
      }
    }
    else if (input.validity.patternMismatch) {
      if (input.type === "email") {
        input.setCustomValidity('Incluya una "@" en la dirección de correo electrónico.')
      }
      if (input.type === "text") {
        input.setCustomValidity('El número de póliza deber iniciar con la letra "M".')
      }
      if (input.type === "number") {
        input.setCustomValidity('Solo se aceptan números')
      }
      // input.setCustomValidity('Campo obligatorio.')
      // input.reportValidity()
    }
    else if (input.validity.tooLong) {
      input.setCustomValidity(`La longitud máxima es de ${input.getAttribute("maxlength")} caracteres`)
    }
    else if (input.validity.tooShort) {
      input.setCustomValidity(`La longitud mínima es de ${input.getAttribute("minlength")} caracteres`)
    }
    else if (input.validity.rangeOverflow) {
      input.setCustomValidity(`El valor máximo es ${input.getAttribute("max")}`)
    }
    else if (input.validity.rangeUnderflow) {
      input.setCustomValidity(`El valor mínimo es ${input.getAttribute("min")}`)
    }
    else {
      //console.log(input.validity)
      input.setCustomValidity('')
    }
    input.reportValidity()
  }

  const GetFormattedDate = (date: Date, days = 0) => {
    let finalDate = date

    var newdate = new Date();
    newdate.setDate(finalDate.getDate() + days);
    finalDate = newdate

    const formatDate = new Date(finalDate.getTime() - finalDate.getTimezoneOffset() * 60 * 1000).toISOString().split('T')[0]

    return formatDate;
  }

  return (
    <>

      {step === 1 &&
        <div className="w-full md:w:2/5 px-5 md:px-0" data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000">
          <form id="formDatosPersonales" onSubmit={submitFormStep1} className="bg-white shadow-lg rounded px-8 pt-6 pb-4 mb-4">
            <div className="flex md:flex lg:flex xl:flex w-full items-center justify-center">
              <img src={logo} alt="" className="object-scale-down"></img>
            </div>
            <div className="divide-y-4 divide-primary divide-opacity-70">
              <div className="text-secondary font-bold pb-2">1.- DATOS PERSONALES</div>
              <div className="pt-5">
                <div className="grid w-full md:flex lg:flex xl:flex grid-cols-1 justify-center">
                  <div className="flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pr-0 md:pr-3 lg:pr-3 xl:pr-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Nombre
                      </label>
                      <input onChange={e => setname(e.target.value)} value={name}  onInput={OnInputEvent} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtNombre" type="text" placeholder="Escriba su nombre" required />
                    </div>
                  </div>
                  <div className="flex md:flex lg:flex xl:flex w-full md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pl-0 md:pl-3 lg:pl-3 xl:pl-3">
                    <div className="mb-4 w-full">
                      <label className="block text-gray-700 text-sm font-bold mb-2">
                        Apellido Paterno
                      </label>
                      <input onChange={e => setmiddlename(e.target.value)} value={middlename} onInput={OnInputEvent} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtApellidoPaterno" type="text" placeholder="Escriba su apellido paterno" required />
                    </div>
                  </div>
                </div>
                <div className="grid w-full md:flex lg:flex xl:flex grid-cols-1 justify-center">
                  <div className="flex md:flex lg:flex xl:flex w-full md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pr-0 md:pr-3 lg:pr-3 xl:pr-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Apellido Materno
                      </label>
                      <input onChange={e => setlastname(e.target.value)} value={lastname} onInput={OnInputEvent} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtApellidoMaterno" type="text" placeholder="Escriba su apellido materno" required />
                    </div>
                  </div>
                  <div className="flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pl-0 md:pl-3 lg:pl-3 xl:pl-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Teléfono
                      </label>
                      <input pattern="[0-9]+" onChange={e => setphone(e.target.value)} value={phone} onInput={OnInputEvent} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white  text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtTelefono" type="number" maxLength={10} placeholder="Escriba su teléfono" required />
                    </div>
                  </div>
                </div>
                <div className="grid w-full md:flex lg:flex xl:flex grid-cols-1 justify-center">
                  <div className="flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pr-0 md:pr-3 lg:pr-3 xl:pr-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Correo electrónico
                      </label>
                      <input pattern="^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$" onInput={OnInputEvent} onChange={e => setmail(e.target.value)} value={mail} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtCorreo" type="email" placeholder="Escriba el correo electrónico" required />
                    </div>
                  </div>
                  <div className="flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pl-0 md:pl-3 lg:pl-3 xl:pl-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Póliza No.
                      </label>
                      <input onChange={e => setfolio(e.target.value)} value={folio} onInput={OnInputEvent} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtFolio" type="text" pattern="^M.*" minLength={8} maxLength={8} placeholder="Escriba el No. de póliza" required />
                    </div>
                  </div>
                </div>
                <div className="grid w-full md:flex lg:flex xl:flex grid-cols-1 justify-center pt-2">
                  <div className="flex md:flex lg:flex xl:flex w-full justify-end items-end">
                    <button disabled={loading} className={`transform hover:translate-y-1 inline-flex items-center hover:scale-110 hover:bg-secondary bg-primary text-white font-bold py-2 px-4 rounded-full ${loading ? "hover:bg-opacity-80" : ""} focus:outline-none focus:shadow-outline transition ease-in-out duration-150 ${loading ? "bg-opacity-80" : ""}`}>
                      {loading && <>
                        <span className="pl-2 pr-2">PROCESANDO</span>
                        <svg className="animate-spin h-5 w-5 mr-3 text-white" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>

                      </>
                      }
                      {!loading &&
                        <span className="pl-2 pr-2">SIGUIENTE</span>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      }
      {step === 2 &&
        <div className="w-full px-3 md:px-0" data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000">
          <form id="formDatosMoto" onSubmit={submitCompleteRegister} className="bg-white shadow-lg rounded px-8 pt-6 pb-4 mb-4">
            <div className="flex md:flex lg:flex xl:flex w-full items-center justify-center">
              <img src={logo} alt="" className="object-scale-down"></img>
            </div>
            <div className="divide-y-4 divide-primary divide-opacity-70">
              <div className="text-gray-700 font-bold pb-2">
                <div className="grid w-full md:flex lg:flex xl:flex grid-cols-1">
                  <div className="flex md:flex lg:flex xl:flex text-secondary md:w-1/2 lg:w-1/2 xl:w-1/2 justify-start items-start">
                    2.- DATOS DE LA MOTO
                  </div>
                  <div className="text-primary font-bold flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:w-1/2 justify-start items-start pt-3 pb-3 md:pb-0 md:pt-0 lg:pb-0 xl:pb-0 lg:pt-0 xl:pt-0 md:justify-end md:items-end lg:justify-end lg:items-end xl:justify-end xl:items-end">
                    PÓLIZA: {folio}
                  </div>
                </div>
              </div>
              <div className="pt-5">
                <div className="grid w-full md:flex lg:flex xl:flex grid-cols-1 justify-center">
                  <div className="flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pr-0 md:pr-3 lg:pr-3 xl:pr-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Marca
                      </label>
                      <input onChange={e => setmarca(e.target.value)} value={marca} onInput={OnInputEvent} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtMarca" type="text" placeholder="Escriba la marca" required />
                    </div>
                  </div>
                  <div className="flex md:flex lg:flex xl:flex w-full md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pl-0 md:pl-3 lg:pl-3 xl:pl-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Modelo
                      </label>
                      <input onChange={e => setmodelo(e.target.value)} value={modelo} onInput={OnInputEvent} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtModelo" type="text" placeholder="Escriba el modelo" required />
                    </div>
                  </div>
                </div>
                <div className="grid w-full md:flex lg:flex xl:flex grid-cols-1 justify-center">
                  <div className="flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:2-1/2 justify-center items-center md:pr-0 md:pr-3 lg:pr-3 xl:pr-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Año
                      </label>
                      <input max={new Date().getFullYear() + 1} onChange={e => setyear(e.target.value)} onInput={OnInputEvent} value={year} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtAño" type="number" minLength={4} maxLength={4} placeholder="Escriba el año" required />
                    </div>
                  </div>
                  <div className="flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pl-0 md:pl-3 lg:pl-3 xl:pl-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Placas
                      </label>
                      <input onChange={e => setplacas(e.target.value)} value={placas} onInput={OnInputEvent} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white  text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100 " id="txtPlacas" type="text" placeholder="Escriba el número de placas" required />
                    </div>
                  </div>
                </div>
                <div className="grid w-full md:flex lg:flex xl:flex grid-cols-1 justify-center">
                  <div className="flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pr-0 md:pr-3 lg:pr-3 xl:pr-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Fecha de compra
                      </label>
                      <input /*onFocus={(e) => e.target.type = 'date' } onBlur={(e) => e.target.type = 'text' }*/ onInput={OnInputEvent} min={GetFormattedDate(new Date(), -179)} max={GetFormattedDate(new Date(), 0)} onChange={e => setfechacompra(e.target.value)} value={fechacompra} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:placeholder-gray-300 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100" id="txtFechaCompra" type="date" placeholder="Seleccione la fecha de compra" required />
                    </div>
                  </div>
                  <div className="flex md:flex lg:flex xl:flex md:w-1/2 lg:w-1/2 xl:w-1/2 justify-center items-center md:pl-0 md:pl-3 lg:pl-3 xl:pl-3">
                    <div className="mb-4 w-full">
                      <label className="block text-secondary text-sm font-bold mb-2">
                        Lugar de compra
                      </label>
                      <input onChange={e => setlugarcompra(e.target.value)} onInput={OnInputEvent} value={lugarcompra} className="flex-1 appearance-none border border-gray-200 w-full py-2 px-4 bg-white text-gray-500 placeholder-gray-300 shadow-md rounded-xl text-base focus:outline-none focus:ring-1 focus:ring-primary focus:ring-opacity-70 focus:border-transparent transform hover:ring-opacity-50 hover:border-secondary hover:translate-y-1 hover:scale-105 transition ease-in duration-100" id="txtLugarCompra" type="text" placeholder="Escriba el lugar de compra" required />
                    </div>
                  </div>
                </div>
                <div className="grid w-full md:flex lg:flex xl:flex grid-cols-1 justify-end pt-2">
                  <div className="flex md:flex lg:flex xl:flex w-auto justify-end items-end md:pr-3 lg:pr-3 xl:pr-3 pb-5 md:pb-0">
                    <button disabled={loading} onClick={backStep} type="button" className={`transform hover:translate-y-1 inline-flex items-center hover:scale-110 hover:bg-secondary bg-primary text-white font-bold py-2 px-4 rounded-full ${loading ? "hover:bg-opacity-80" : ""} focus:outline-none focus:shadow-outline transition ease-in-out duration-150 ${loading ? "bg-opacity-80" : ""}`}>
                      <span className="pl-2 pr-2">ANTERIOR</span>
                    </button>
                  </div>
                  <div className="flex md:flex lg:flex xl:flex w-auto justify-end items-start">
                    <button disabled={loading} className={`transform hover:translate-y-1 inline-flex items-center hover:scale-110 hover:bg-secondary bg-primary text-white font-bold py-2 px-4 rounded-full ${loading ? "hover:bg-opacity-80" : ""} focus:outline-none focus:shadow-outline transition ease-in-out duration-150 ${loading ? "bg-opacity-80" : ""}`}>
                      {loading && <>
                        <span className="pl-2 pr-2">PROCESANDO</span>
                        <svg className="animate-spin h-5 w-5 mr-3 text-white" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </>
                      }
                      {!loading &&
                        <span className="pl-2 pr-2">COMPLETAR REGISTRO</span>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      }
    </>
  );
}